<template>
  <div class="case-journal">
    <Row class="audit-log-block">
      <Row class="time-line-body">
        <Timeline>
          <TimelineItem v-for="(item,index) in journalList" :key="index">
            <!-- <i :class="!renderColor(item.operation)?'icon-correct-01':'icon-down-01'" slot="dot"></i> -->
            <Icon slot="dot" type="ios-radio-button-on" :size="18" :color="styles.globalMainColor" />
            <!-- <Icon type="ios-radio-button-on" /> -->
            <Row class="line-content">
              <img class="line-avatar" :src="item.headImgUrl || defaultIcon" alt="">
              <Row class="line-right">
                <span class="line-name">{{ item.operatorName || "" }}</span>
                <span style="margin-right:6px;">{{ item.operateName || "" }}</span>
                <span style="margin-right:6px;">{{ item.remark || "" }}</span>
                <span>{{ item.newValue }}</span>
                <span v-if="item.operateTime" class="line-time">{{ item.operateTime.split('T')[0] }} {{ item.operateTime.split('T')[1] }}</span>
                <span v-else class="line-time">{{ "" }}</span>
                <!-- <Row class="line-remark" v-if="item.operation=='2' || item.operation=='3'">
                                    <span class="line-left-label" v-if="item.operation=='2'">驳回原因：</span>
                                    <span class="line-left-label" v-if="item.operation=='3'">终止原因：</span>
                                    <span class="line-right-content">{{item.reason || ""}}</span>
                                </Row> -->
              </Row>
            </Row>
          </TimelineItem>
        </Timeline>
      </Row>
    </Row>
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
import defaultIcon from '@/assets/images/card-02.png'
export default {
  components: {},
  props: ['caseId'],
  data () {
    return {
      journalList: [],
      styles: styles,
      defaultIcon: defaultIcon
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {
    this.getData()
  },
  updated() {},
  methods: {
    getData() {
      const url = '/business/case-logs/case'
      const ajaxData = {
        caseId: this.caseId
      }
      this.$get(url, ajaxData).then(res => {
        if (res.code == 0) {
          this.journalList = res.data || []
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/globalStyle.scss";
.case-journal{
    .audit-log-block{
        margin-top: 30px;
        padding:0 50px 5px 50px;
    }
    .tag{
        background: transparent;
        border:1px solid $globalMainColor;
        color:$textColor;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/case/caseJournal.vue